import React from 'react';
import { Icon, TextareaReadOnly, textareaInitialState, Pill } from '../../';
import { AttributeSensitivity, formatData, DatasetSubtypeOperation } from '../../../helpers';

export const formatChangelogValue = (version, data) => {
  let key = data.property;
  let values = version === 'new' ? data.new_data : data.old_data;
  let value = values && values[key];

  if (typeof value === 'boolean') {
    value = value ? 'Yes' : 'No';
  }

  let isSecretValue = data.is_secret;
  value = isSecretValue && value !== undefined && value !== null ? '< hidden >' : value;

  let element;

  if (value !== undefined && value !== null) {
    switch (key) {
      case 'dataset_id':
        element = values.dataset_name ? (
          <div className="with-icon">
            <Icon name={values.dataset_type_name} tooltip={values.dataset_type_name} />
            {values.dataset_name}
          </div>
        ) : (
          <span>{values.dataset_id.toString()}</span>
        );
        break;
      case 'dataset_group_id':
        value = values.dataset_group_name || values.dataset_group_id.toString();
        element = <span>{value}</span>;
        break;
      case 'datasource_id':
        element = values.datasource_name ? (
          <div className="with-icon">
            <Icon name={values.datasource_type_category} tooltip={values.datasource_type_name} />
            {values.datasource_name}
          </div>
        ) : (
          <span>{values.datasource_id.toString()}</span>
        );
        break;
      case 'attribute_id':
        element = values.attribute_name ? (
          <div className="with-icon">
            <Icon name={values.attribute_role_name} tooltip={values.attribute_role_name} />
            {values.attribute_name}
          </div>
        ) : (
          <span>{values.attribute_id.toString()}</span>
        );
        break;
      case 'glossary_id':
        value = values.glossary_name || values.glossary_id.toString();
        element = <span>{value}</span>;
        break;
      case 'system_id':
        value = values.system_name || values.system_id.toString();
        element = <span>{value}</span>;
        break;
      case 'entity_type_id':
        // An entity's type is optional, so an entry that sets it back to none shows as null above; this
        // branch only runs when there is a type to name.
        value = values.entity_type_name || values.entity_type_id.toString();
        element = <span>{value}</span>;
        break;
      case 'parent_entity_id':
        // Both an entity and an attribute can be moved under a different entity, and both changelog
        // views resolve the name under the same key.
        value = values.parent_entity_name || values.parent_entity_id.toString();
        element = <span>{value}</span>;
        break;

      case 'datasource_type_id':
        element = (
          <div className="with-icon">
            <Icon name={values.datasource_type_category} tooltip={values.datasource_type_name} />
            {values.datasource_type_name}
          </div>
        );
        break;
      case 'dataset_type_id':
        element = (
          <div className="with-icon">
            <Icon name={values.dataset_type_name} tooltip={values.dataset_type_name} />
            {values.dataset_type_name}
          </div>
        );
        break;
      case 'dataset_subtype_id':
        element = (
          <Pill
            label={values.dataset_subtype_name}
            className={DatasetSubtypeOperation[values.dataset_subtype_operation]?.className}
          />
        );
        break;
      case 'datatype_id':
        element = (
          <div className="with-icon">
            <Icon name={values.datatype_category} tooltip={values.datatype_fullname} />
            {values.datatype_fullname}
          </div>
        );
        break;
      case 'attribute_role_id':
        element = (
          <div className="with-icon">
            <Icon name={values.attribute_role_name} tooltip={values.attribute_role_name} />
            {values.attribute_role_name}
          </div>
        );
        break;
      case 'attribute_sensitivity_id':
        element = (
          <Icon
            name="attribute_sensitivity"
            label={values.attribute_sensitivity_name}
            value={values.attribute_sensitivity_level}
            values={AttributeSensitivity}
          />
        );
        break;

      case 'status_id':
        element = <Pill label={values.status_id} values={'statuses'} />;
        break;

      case 'owner_principal_id':
        value =
          values.principal_name ||
          'Deleted principal with id ' + values.owner_principal_id.toString();
        element = <div>{value}</div>;
        break;

      case 'dataset_technical_definition':
      case 'dataset_technical_definition_raw':
      case 'field_technical_definition':
        value = value || null;
        element = <div className="code">{value.toString()}</div>;
        break;

      case 'datasource_filter':
      case 'relationship_map':
        value = value ? JSON.stringify(value) : null;
        element = <div className="code">{value}</div>;
        break;

      case 'entity_description':
      case 'dataset_description':
      case 'dataset_group_description':
      case 'datasource_description':
      case 'attribute_description':
      case 'attribute_value_description':
      case 'attribute_definition':
      case 'glossary_description':
      case 'system_description':
        value = value || null;
        element = (
          <TextareaReadOnly value={textareaInitialState({ value: value, readOnly: true })} />
        );
        break;

      case 'attribute_unit_id':
        value = value ? `${values.attribute_unit_name} (${values.attribute_unit_code})` : null;
        element = <span>{value}</span>;
        break;

      case 'user_group_default_role_id':
      case 'user_role_id':
        value = value ? `${values.user_role_name}` : null;
        element = <span>{value}</span>;
        break;

      case 'user_is_enabled':
        element =
          value === 'No' ? (
            <span className="pill pill-red">Disabled</span>
          ) : (
            <span className="pill">Enabled</span>
          );
        break;

      case 'user_photo':
      case 'user_group_photo':
        value = value || null;
        element = formatData('user-photo', 'owner', undefined, undefined, undefined, {
          photo: value,
        });
        break;

      default:
        element = isSecretValue ? (
          <span className="secret changelog-no-value">{value}</span>
        ) : (
          <span className={!value ? 'changelog-no-value' : ''}>{value || 'null'}</span>
        );
    }
  } else {
    element = <span className="changelog-no-value">null</span>;
  }

  return element;
};
